import { computed, makeObservable } from 'mobx';

import { CallProviderType } from '@gem/call/Model/callModel.types';

import Entities from 'STORE';
import { Group } from 'STORE/Groups/Group';
import { User } from 'STORE/Users/User/User';

import { CallVisibleDurationService } from './Services/CallVisibleDurationService/CallVisibleDurationService';
import { callStreamService } from './Services/callStreamService/callStreamService';

interface IIncomingCallConstructorParams {
  groupId?: string;
  channelId: string;
  initiatorId: string;
  callVisibleDuration: number;
  callProvider: CallProviderType;
}

export class IncomingCall {
  groupId: string | null = null;
  channelId: string;
  initiatorId: string;
  callProvider: CallProviderType;
  callVisibleDuration: number;
  callVisibleDurationService: CallVisibleDurationService;
  disposeCallStream: () => void;

  constructor({
    groupId,
    channelId,
    initiatorId,
    callVisibleDuration,
    callProvider,
  }: IIncomingCallConstructorParams) {
    makeObservable(this);
    this.groupId = groupId || null;
    this.channelId = channelId;
    this.initiatorId = initiatorId;
    this.callProvider = callProvider;
    this.callVisibleDuration = callVisibleDuration;

    this.callVisibleDurationService = new CallVisibleDurationService(this);
    this.disposeCallStream = callStreamService(this);
  }

  dispose = (): void => {
    this.callVisibleDurationService.dispose();
    this.disposeCallStream();
  };

  @computed
  get group(): Group | null {
    return this.groupId ? Entities.GroupsStore.getGroupById(this.groupId) : null;
  }

  @computed
  get isGroup(): boolean {
    return !!this.group?.isChatGroup;
  }

  @computed
  get isP2P(): boolean {
    return !!this.group?.isP2P;
  }

  @computed
  get initiatorUser(): User {
    return Entities.usersStore.getUserById(this.initiatorId)!;
  }
}
